var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0067 12.6317C32.3267 8.31999 26.0217 8.68832 25.415 8.68832C18.0484 8.90499 13.78 13.6933 13.78 13.6933L15.47 15.4267C19.2184 11.3967 24.4617 10.92 25.5884 10.9417C31.9367 11.115 35.2517 14.2783 35.2517 14.2783H33.8867L33.93 16.5317H39.39V10.985H37.0067C37.0067 10.985 37.0934 12.2633 37.0067 12.6317Z",
    fill: "#BD161D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4767 41.08C20.1284 40.9067 16.8134 37.7433 16.8134 37.7433H18.1784L18.135 35.49H12.675V41.0367H15.0584C15.0584 41.0367 14.9717 39.7583 15.0584 39.39C19.7384 43.7017 26.0434 43.3333 26.65 43.3333C34.0167 43.1167 38.285 38.3283 38.285 38.3283L36.595 36.595C32.8467 40.625 27.6034 41.1017 26.4767 41.08Z",
    fill: "#BD161D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16504 30.16C9.16504 30.16 9.88004 32.63 10.3784 33.475L12.5017 32.63C12.5017 32.63 11.4184 29.9 11.44 29.51C11.0284 29.575 9.16504 30.16 9.16504 30.16Z",
    fill: "#BD161D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0284 24.115C11.0284 24.115 9.18673 24.0283 8.81839 24.0283C8.64506 24.0933 8.71006 27.5383 8.71006 27.5383H11.0284C10.9851 26.8667 11.0284 24.1367 11.0284 24.1367V24.115Z",
    fill: "#BD161D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29504 21.4067L11.44 22.1217C11.5484 21.645 12.5884 18.98 12.5884 18.98C12.5884 18.98 10.855 18.1783 10.5517 18.07C10.2917 18.3517 9.29504 21.4067 9.29504 21.4067Z",
    fill: "#BD161D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.39 33.02L41.4916 33.8867C41.99 33.0634 42.7483 30.5934 42.7483 30.5934C42.7483 30.5934 40.885 29.9867 40.4733 29.9C40.4733 30.29 39.3683 33.02 39.3683 33.02H39.39Z",
    fill: "#BD161D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.225 24.4617C42.8567 24.4617 41.015 24.5267 41.015 24.5267C41.015 24.5267 41.015 27.2567 40.9717 27.9283L43.29 27.9717C43.29 27.9717 43.3983 24.5483 43.2467 24.4617H43.225Z",
    fill: "#BD161D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.77 21.84C42.77 21.84 41.8167 18.7634 41.5567 18.4817C41.2534 18.59 39.52 19.37 39.52 19.37C39.52 19.37 40.5167 22.0784 40.625 22.5334L42.7917 21.84H42.77Z",
    fill: "#BD161D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3617 28.34C28.3617 27.69 27.8417 27.17 27.1917 27.17H24.895V29.5316H27.1917C27.8417 29.5316 28.3617 29.0116 28.3617 28.3616V28.34Z",
    fill: "#BD161D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3617 23.6817C28.3617 23.0317 27.8417 22.5117 27.1917 22.5117H24.895V24.8733H27.1917C27.8417 24.8733 28.3617 24.3533 28.3617 23.7033V23.6817Z",
    fill: "#BD161D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5483 26C37.5483 19.63 32.3917 14.4733 26.0217 14.4733C19.6517 14.4733 14.495 19.63 14.495 26C14.495 32.37 19.6517 37.5267 26.0217 37.5267C32.3917 37.5267 37.5483 32.37 37.5483 26ZM24.8083 31.7633L21.4283 31.72V29.51H22.5117V22.5333H21.4283V20.2583H24.8083V19.0233H27.17V20.2583C27.17 20.2583 29.705 20.215 30.4417 22.5333C30.55 22.9667 31.07 24.5267 29.77 26C30.095 26.4117 31.1783 27.625 30.29 29.9217C30.0733 30.29 29.1633 31.8067 27.1917 31.72V32.955H24.8733L24.8083 31.7633Z",
    fill: "#BD161D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.8122dbdb21d570bf4f77dae28928f932.svg";
export { ForwardRef as ReactComponent };